import React, {useEffect, useState} from "react";
import {DocTitle} from "../../components";
import {DocumentsBatch, RefpadoDocument} from "../../types";
import {QRFooter} from "../qr_footer/QRFooter";
import {HousebookResponse} from "../../types/housebook";
import {DocTable} from "../../components/doc_table/DocTable";
import {selectedDocument} from "./index";
import {AvailableDocuments} from "./AvailableDocuments";
import {mayBe} from "./utils";


export const HousebookDoc: React.FC<{ documents: DocumentsBatch, withVersions?: boolean }> = ({
                                                                                                  documents,
                                                                                                  withVersions = true
                                                                                              }) => {

    const [selectedDocument, setSelectedDocument] = useState<selectedDocument>(
            {
                document: documents.documents[0],
                documentTypeName: documents.documentsType
            });

    const [doc, setDocument] = useState<HousebookResponse>(
            selectedDocument.document.document as HousebookResponse
    )

    useEffect(() => {
        setDocument(selectedDocument.document.document as HousebookResponse);
    }, [selectedDocument.document.version]);


    const title = `Выписка из домовой книги № ${mayBe(doc?.houseBookCopy?.docnum || 'б/н')}`;
    const subTitle = doc.houseBookCopy.addrstr;

    const getDocument = (document: RefpadoDocument) => {
        const {documentType, serial = '', number = '', issuedBy = '', issuedDate = ''} = document;
        if (!serial && !number && !issuedBy && !issuedDate) {
            return documentType;
        }
        return `${documentType} ${serial} №${number}, выдан ${issuedBy} от ${issuedDate}`;
    };

    return (
            <>
                <div className="col-span-12 md:col-span-12">
                    <DocTitle title={title} subtitle={subTitle} uid={doc.blockchainUid}/>
                </div>


                <div className="col-span-12 md:col-span-8">
                    <DocTable
                            className={'doc-table--refdebt-services bottom-line'}
                            title={''}
                            headers={[
                                'ФИО, место рождения, дата рождения',
                                'Когда и откуда прибыл',
                                'Вид регистрации',
                                'Гражданство, паспорт',
                                'Дата регистрации',
                                'Когда и куда выбыл',
                            ]}
                            rows={doc.houseBookCopy.person.map(p => [
                                p.fio,
                                p.fromAddr,
                                p.regType,
                                `гр. ${p.grajd}, ${p.document}`,
                                p.regDate,
                                p.outAddr
                            ])}
                            empty={''}/>

                    <QRFooter blockchainUid={doc.blockchainUid}
                              refDate={doc.houseBookCopy.curdate}
                              mfcInfoName={doc.firmName}
                              mfcUserName={doc.username}
                    />
                </div>

                {
                        withVersions && documents.documents.length > 0 &&
                        <div className="col-span-12 md:col-end-13 md:col-span-3 order-first md:order-last">
                            <AvailableDocuments
                                    docs={documents}
                                    setSelectedDocument={setSelectedDocument}
                                    className={'-mt-12'}
                            />
                        </div>
                }
            </>
    );
};
